module.exports = new __parcel__URL__("intro-view.d6cf4305.svg").toString();